


















import mixins from 'vue-typed-mixins';
export default mixins().extend({
  computed: {
    permission() {
      return {
        visible: this.$session?.role?.type !== 'serviceprovider',
      };
    },
  },
});
